// How a module looks on the canvas and in lists: a colour per app and a
// Remix icon per schema icon name (ModuleSchema::$icon in the cabinet).
// The app bundles Remix Icon v2.5 (assets/scss/plugins/icons/_remixicon.scss): icons added in
// later versions (the sparkling, AI-image and puzzle ones, for example) render as nothing, so
// moduleStyle.test checks every icon class used here against that stylesheet.

const APP_COLORS: Record<string, string> = {
    builtin: '#7b5cd6',
    util: '#16a085',
    http: '#2980b9',
    json: '#d35400',
    regexp: '#c0392b',
    gateway: '#e84393',
    'm9s-ai': '#8e44ad',
    'm9s-approval': '#f39c12',
    'm9s-content': '#0ab39c',
    'm9s-engagement': '#299cdb',
    'm9s-bot': '#405189',
    'm9s-sales': '#f06548',
    'm9s-task': '#6c757d',
    datastore: '#8a6d3b',
};

const ICONS: Record<string, string> = {
    router: 'ri-git-branch-line',
    iterator: 'ri-list-ordered',
    aggregator: 'ri-stack-line',
    repeat: 'ri-repeat-line',
    'error-handler': 'ri-error-warning-line',
    variable: 'ri-braces-line',
    clock: 'ri-time-line',
    switch: 'ri-toggle-line',
    text: 'ri-text',
    json: 'ri-code-s-slash-line',
    http: 'ri-global-line',
    webhook: 'ri-links-line',
    tool: 'ri-tools-line',
    ai: 'ri-magic-line',
    approval: 'ri-checkbox-circle-line',
    post: 'ri-article-line',
    message: 'ri-chat-3-line',
    comment: 'ri-discuss-line',
    handoff: 'ri-customer-service-2-line',
    stop: 'ri-stop-circle-line',
    order: 'ri-shopping-cart-2-line',
    product: 'ri-price-tag-3-line',
    customer: 'ri-user-heart-line',
    task: 'ri-task-line',
    database: 'ri-database-2-line',
    trophy: 'ri-trophy-line',
    image: 'ri-image-edit-line',
    video: 'ri-film-line',
};

export const appOf = (moduleKey: string): string => moduleKey.split(':')[0] || '';

export const moduleColor = (moduleKey: string): string => {
    const app = appOf(moduleKey);
    if (APP_COLORS[app]) {
        return APP_COLORS[app];
    }

    return app.startsWith('m9s') ? '#0ab39c' : '#878a99';
};

export const moduleIcon = (icon: string | undefined): string => ICONS[icon || ''] || 'ri-apps-2-line';
